<template>
  <div>
    <div class="modal_header">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24">
          <div class="grid-content bg-purple">
            <div class="title_h">
              {{ $t("message.add_promotion") }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24">
          <div class="grid-content bg-purple-light">
            <el-row class="button_r">
              <el-button
                type="success"
                :loading="loadingButton"
                :disabled="loadingButton ? true : false"
                @click="submit"
                >{{ $t("message.save_and_close") }}</el-button
              >
              <el-button @click="close()">{{
                $t("message.close")
              }}</el-button>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- ****************   Start Molad-content  Modal **************** -->

    <div class="modal-body mt-3">
      <el-form
        ref="form"
        status-icon
        :model="form"
        :rules="rules"
        :label-position="'left'"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="name" :label="$t(`message.name`)">
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="start" :label="$t(`message.start`)">
              <el-date-picker
                v-model="form.start"
                type="date"
                :format="'yyyy-MM-dd'"
                :value-format="'yyyy-MM-dd'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="end" :label="$t(`message.end`)">
              <el-date-picker
                v-model="form.end"
                type="date"
                :format="'yyyy-MM-dd'"
                :value-format="'yyyy-MM-dd'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-select
              v-model="selected_service"
              filterable
              clearable
              class="w-100"
            >
              <el-option
                style="width: 500px"
                v-for="service in inventory"
                :key="service.id"
                :value="service.id"
                :label="service.name"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-button
              @click="chooseService(selected_service)"
              :disabled="!selected_service"
              type="success"
              class="w-100"
            >{{
                $t(`message.choose`)
              }}</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-3">
          <el-table border :data="services">
            <el-table-column label="№" prop="id" width="70" align="center"></el-table-column>
            <el-table-column :label="$t(`message.name`)" prop="name"></el-table-column>
            <el-table-column :label="$t(`message.price`)" prop="price" align="center" width="180"></el-table-column>
            <el-table-column :label="$t(`message.discount_price`)" prop="discount_price" width="180">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.discount_price"
                  type="number"
                />
              </template>
            </el-table-column>
            <el-table-column :label="$t(`message.secondary_discount_price`)" prop="discount_price" width="180">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.secondary_discount_price"
                    type="number"
                />
              </template>
            </el-table-column>
            <el-table-column prop="delete" :label="$t(`message.delete`)" width="120">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="deleteService(scope.$index)"
                />
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import form from "@/utils/mixins/form";
import currencies from "@/components/inventory-select/currencies";
import drawerChild from "@/utils/mixins/drawer-child";
export default {
  components: { currencies },
  mixins: [form, drawerChild],
  data() {
    return {
      selected_service: null,
      services: [],
    };
  },
  computed: {
    ...mapGetters({
      model: "promotions/model",
      rules: "promotions/rules",
      inventory: "services/inventory",
    }),
  },
  async mounted() {
    if (this.services && this.services.length === 0) await this.loadServices();
  },
  methods: {
    ...mapActions({
      save: "promotions/store",
      loadServices: "services/inventory",
    }),
    afterOpened() {
      this.form = JSON.parse(JSON.stringify(this.model));
    },
    afterClosed() {
      this.empty();
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          this.form.services = JSON.parse(JSON.stringify(this.services))

          this.save(this.form)
            .then((res) => {
              this.loadingButton = false;
              this.$notify({
                title: 'Успешно',
                type: "success",
                offset: 130,
                message: res.message
              });
              this.services = [];
              this.parent().listChanged();
              this.parent().refresh();
              this.close();
            })
            .catch((err) => {
              this.$notify({
                title: 'Ошибка',
                type: "error",
                offset: 130,
                message: err.error.message
              });
              this.loadingButton = false;
            })
            .finally(() => {
              this.$refs["form"].resetFields();
              this.empty();
              this.parent().listChanged();
              this.close();
            });
        }
      });
    },
    chooseService(id) {
      const service = this.inventory.find(item => item.id === id);
      this.services.push({
        id: service.id,
        name: service.name,
        price: service.price,
        discount_price: 0,
        residence_discount_price: null,
        secondary_discount_price: null,
      });
      this.selected_service = null;
    },
    deleteService(index) {
      this.services.splice(index, 1);
    },
  },
};
</script>
<style scoped lang="scss">
.el-select-dropdown__item {
  white-space: nowrap;
  overflow-x: auto;
  text-overflow: unset;
  max-width: none;
}
.el-select-dropdown {
  width: 500px !important;
}
</style>